import type { NewsItem, FeaturedExample, GalleryExample, TextExample } from "@/app/core/mainPage/prompt/shared/types";
export const en = {
  settings: 'Settings',
  theme: 'Theme',
  language: 'Language',
  light: 'Light',
  dark: 'Dark',
  auto: 'Auto',
  russian: 'Russian',
  english: 'English',
  profile: 'Profile',
  topUp: 'Top Up',
  main: 'Home',
  create: 'Create',
  chats: 'Chats',
  gallery: 'Image Gallery',
  examples: 'Popular Examples',
  tryThis: 'Try This',
  startCreating: 'Start Creating Now',
  joinThousands: 'Join thousands of users already creating content with AI',
  tryFree: 'Try for Free',
  createWithAI: 'Create with AI',
  generateTextsImages: 'Generate texts, images and more. Get inspired by the examples below or start with your own idea.',
  viewAll: 'View All',
  universalChat: 'Universal Chat',
  pinterest: 'Pinterest',
  copyPrompt: 'Copy prompt',
  packages: 'Token Packages',
  buy: 'Buy',
  compareFeatures: 'Compare Features',
  faq: 'FAQ',
  balance: 'Balance',
  orderDetails: 'Order Details',
  tokenPackage: 'Token Package',
  total: 'Total',
  packageContents: 'Package Contents',
  paymentMethod: 'Payment Method',
  telegramPayments: 'Telegram Payments',
  securePayment: 'Secure payment via Telegram invoice.',
  pay: 'Pay',
  checkout: 'Checkout',
  buyTokens: 'Buy Tokens',
  chooseTokenPackage: 'Choose a token package to top up your balance',
  saveMore: '💡 Save more with larger packages',
  bestValue: 'Best Value',
  best: 'Best',
  tokens: 'tokens',
  pricePer100: 'per 100 tokens',
  noProducts: 'No products yet. Check back later.',
  catalogUnavailable: 'Catalog temporarily unavailable: ',
  buyNow: 'Buy Now',
  inviteFriends: 'Invite Friends',
  inviteAndEarn: 'Invite and Earn',
  friendDiscount: 'Your friend will get a {discount}% discount on their first purchase',
  yourReferralLink: 'Your Referral Link',
  copyLink: 'Copy Link',
  copied: 'Copied!',
  recentInvites: 'Recent Invites',
  noInvites: 'You haven\'t invited anyone yet. Share your link!',
  howItWorks: 'How does it work?',
  step1: '1. Copy your referral link and send it to a friend.',
  step2: '2. Friend registers — you become their referrer.',
  step3: '3. Friend gets a {discount}% discount on their first subscription purchase.',
  featuredExamplesTitle: 'Popular Examples',
  galleryExamplesTitle: 'Image Gallery',
  textExamplesTitle: 'Text Examples',
  quickPromptsTitle: 'Try This',
  tryThesePrompts: 'Try These Prompts',
  copyPromptButton: 'Copy Prompt',
  promptPlaceholder: 'E.g.: "Create a product launch plan" or "Come up with a visual concept for the cover"',
  tokensRemainingLabel: 'Tokens remaining',
  yourReferralCode: 'Your referral code',
  shortcutHint: 'Ctrl/Cmd + Enter to run',
  createChat: 'Create Chat',
  selectChatType: 'Select chat type',
  newChat: 'New Chat',
  newChatDescription: 'Start a new AI conversation',
  myChats: 'My Chats',
  myChatsDescription: 'Your chat history',
  soonMessage: 'Coming soon',
  soon: 'Soon',
  close: 'Close', 
  selectModel: "Select AI model",
  back: "Back",
  openSidebar: "Open conversation list",
  aiAssistant: "AI assistant",
  welcomeTitle: "Start a new conversation",
  welcomeDescription: "Choose a model, ask a question and get a streaming response right here.",
  welcomeHistoryMessage: "Message history for this conversation is not yet loaded, but you can continue chatting in its current context.",
  example1:"Formulate a plan to solve the problem",
  example2: "Help improve the text for a client",
  example3: "Summarize the document",
  inputPlaceholder: "Enter a message...",
  generating: "Generating response...",
  sendMessage: "Send message",
  stopGeneration: "Stop generation",
  copy: "Copy",
  regenerate: "Regenerate",
  tryAgain: "Try again",
  generationStopped: "Stopped",
  generationError: "Generation failed",
  dialogues:  "Dialogues",
  newConversation: "New conversation",
  searchConversation: "Search conversation...",
  noConversations:  "No conversations yet",
  noConversationsHint: "Start a new conversation and it will appear here.",
  noSearchResults:  "Nothing found",
  noSearchResultsHint:  "Try changing your search query.",
  selectModelTitle:  "Select AI Model",
  chatHistory:  "Chat History",
  openChat: "Open chat",
  stopped: 'Stopped',
  justNow: 'Just now',
  minAgo: 'min ago',
  hourAgo: 'h ago',
  yesterday: 'Yesterday',
  daysAgo: 'days ago',
  untitled: 'Untitled',
  chatExample1Title: 'Python code help',
  chatExample1Preview: 'Can you help write a function for...',
  chatExample2Title: 'Article ideas',
  chatExample2Preview: 'Need ideas for an AI article...',
  chatExample3Title: 'Text translation',
  chatExample3Preview: 'Translate this text into English...',
  fastStart: 'Quick start in chat',
  suitableForDaily: 'Suitable for daily tasks',
  qualityDependsOnPrompt: 'Quality depends on prompt wording',
  dialogue: 'Dialogue',
  textGeneration: 'Text generation',
  strongComplexInstructions: 'Strong with complex instructions',
  holdsLongContext: 'Holds long context well',
  universalBalance: 'Universal balance of speed and quality',
  codeAndAnalysis: 'Code and analysis',
  largeDocuments: 'Large documents',
  fastAnswers: 'Fast answers',
  contextStandard: 'Context: standard',
  showDetails: 'Show details',
  strengths: 'Strengths',
  weaknesses: 'Weaknesses',
  idealFor: 'Ideal for:',
  gpt41Description: 'The most powerful model',
  gpt4oDescription: 'Fast and efficient',
  claude3Description: 'Good for long texts',
  geminiDescription: 'From Google',
  myChatsDescriptionActive: 'Your chat history',
  textModels: 'Text',
  imageModels: 'Photo',
  videoModels: 'Video',
  models: 'Models',
  noModelsAvailable: 'No models available',
  proSettings: 'Pro generate',
  proSettingsDescription: 'Here you can configure image and video generation parameters. Full settings will be available soon.',
  generate: 'Generate',
  newsTitle: 'News',
  topModels: "Top models",
  addedDate: "Added",
  tryModel: "Try it",
  wsReconnecting: "Reconnecting WebSocket...",
  wsError: "Connection lost",
  wsRestored: "Connection restored",
  retry: "Retry",
  yourOrder: "Your order",
  promoCode: "Promo code",
  enterPromoCode: "Enter promo code",
  apply: "Apply",
  promoApplied: "Promo code applied:",
  promoNotApplied: "Promo code not applied",
  subtotal: "Subtotal",
  referralDiscount: "Referral discount",
  promoDiscount: "Promo discount",
  toPay: "To pay",
  delete: "Delete",
  cancel: "Cancel",
  thinking: "Thinking...",
  callingLlm: "Calling LLM...",
  toolRunning: "Tool running...",
  executingTools: "Executing tools...",
  processing: "Processing...",
  completed: "Completed",
  running: "Running...",
  promoEmpty: "Promo code is empty",
  promoSuccess: "Promo code applied successfully",
  promoAlreadyRedeemed: "Promo code has already been redeemed",
  promoError: "Error applying promo code",
  aboutApp: "About the App",
  termsOfUse: "Terms of Use",
  privacyPolicy: "Privacy Policy",
  support: "Support",
  version: "App Version",
  tokensUsedLabel: "Tokens used",
  calling_llm: "Calling LLM...",
  generating_image: "Generating image",
  tool_running: "Running tool",
  executing_tools: "Executing tools",
  goodMorning: 'Good morning',
  goodAfternoon: 'Good afternoon',
  goodEvening: 'Good evening',
  goodNight: 'Good night',
  welcomeTitle1: 'Welcome!',
  welcomeDesc1: "Glad to see you here. Ready to start working with AI?",
  welcomeTitle2: 'AI power in your hands',
  welcomeDesc2: 'Create texts, images, and videos with cutting-edge models.',
  welcomeTitle3: 'A gift for you!',
  welcomeDesc3: 'Get 100 welcome tokens and try generations right now.',
  welcomeTitle4: 'Where to start?',
  welcomeDesc4: 'Choose what you want to generate first.',
  welcomeText: 'Text',
  welcomeTextDesc: 'Articles, code, answers',
  welcomeImage: 'Image',
  welcomeImageDesc: 'Art, logos, photos',
  welcomeVideo: 'Video',
  welcomeVideoDesc: 'Animations and clips',
  stepLabel: 'Step',
  agentThinking: 'Agent is working',
  toolsLabel: 'tools',
  phaseQueued: 'Queued',
  phaseRunning: 'Running',
  phaseFetching: 'Fetching',
  phaseStoring: 'Storing',
  phaseCallingLlm: 'Calling LLM',
  phaseExecutingTools: 'Executing tools',
  phaseGeneratingImage: 'Generating image',
  phaseGeneratingVideo: 'Generating video',
  phaseGenerating: 'Generating',
  phaseThinking: 'Thinking',
  consiliumLabel: 'Consilium',
  imageModelLabel: 'Image AI',
  videoModelLabel: 'Video AI',
  searchToolLabel: 'Web Search',
  stepsLabel: 'Steps',
  agentStarting: 'Starting…',
  noSteps: 'No data',
  extractToolLabel: 'Extract',
  agentAwaiting: 'Awaiting confirmation',
  reasoning: 'Reasoning',
  confirm: 'Confirm',
  reject: 'Reject',
  continue: 'Continue',

  //новостной блок
newsItems: [
  {
    id: 'update-2.1',
    title: 'Update 2.1',
    summary: 'Added support for GPT-4o and Claude 3.5 Sonnet, improved generation speed by 1.5x.',
    fullText: 'We are excited to present update 2.1! This version adds support for the latest models GPT-4o and Claude 3.5 Sonnet. Text generation speed has been increased by 1.5 times thanks to WebSocket optimizations. Mobile layout bugs have been fixed, and transition animations between tabs have been added.',
    imageUrl: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=600',
  },
] as NewsItem[],
noNews: 'No news yet.',



//фото примеры
   featuredExamples: [
    {
      id: "feat-1",
      prompt: "Futuristic city at sunset with flying cars and skyscrapers",
      type: "image",
      imageUrl: "https://images.unsplash.com/photo-1759558909137-af1027a6a026?w=1080",
    },
    {
      id: "feat-2",
      prompt: "Write a marketing strategy for launching a new mobile app",
      type: "text",
      result:
        "A successful mobile app launch requires a comprehensive approach. Start with a pre-launch campaign 2-3 months before release: create a landing page, start collecting email subscribers, and activate social media channels.",
    },
  ] as FeaturedExample[],

  //фото примеры
  galleryExamples: [
    { id: "img-1", prompt: "Abstract composition in Kandinsky style", imageUrl: "https://images.unsplash.com/photo-1741434056721-8e4e84f7aee3?w=1080", height: 400 },
    { id: "img-2", prompt: "Minimalist workspace", imageUrl: "https://images.unsplash.com/photo-1772751541531-e084e8f56630?w=1080", height: 500 },
    { id: "img-3", prompt: "Mountain landscape at dawn", imageUrl: "https://images.unsplash.com/photo-1600257729950-13a634d32697?w=1080", height: 450 },
    { id: "img-4", prompt: "Modern architecture", imageUrl: "https://images.unsplash.com/photo-1695067439031-f59068994fae?w=1080", height: 550 },
    { id: "img-5", prompt: "Colorful gradient art", imageUrl: "https://images.unsplash.com/photo-1665764884116-11bf71512155?w=1080", height: 400 },
  ] as GalleryExample[],

  //текстовые примеры
  textExamples: [
    {
      id: "text-1",
      prompt: "Write a resume for a Senior Frontend Developer position",
      preview:
        "JOHN DOE\nSenior Frontend Developer\n\nEXPERIENCE:\n• Senior Frontend Developer, Tech Corp (2021-Present)\n  - Led a team of 5 developers",
    },
    {
      id: "text-2",
      prompt: "Write an article plan about artificial intelligence in medicine",
      preview:
        "1. Introduction: The AI revolution in healthcare\n2. Disease diagnosis with machine learning\n3. Personalized medicine and forecasting",
    },
    {
      id: "text-3",
      prompt: "Create a product description for a marketplace",
      preview:
        "Wireless Headphones Premium Sound Pro X\n\nImmerse yourself in crystal clear sound with next-generation active noise cancellation. 40 hours of battery life.",
    },
    {
      id: "text-4",
      prompt: "Write an apology letter to a client for a delay",
      preview:
        "Dear [Name],\n\nPlease accept our sincere apologies for the delay in fulfilling your order. We understand the importance of timely delivery and deeply regret the inconvenience caused.",
    },
    {
    id: "img-6",
    prompt: "Уютный интерьер",
    imageUrl: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400",
    height: 450,
   },
    {
    id: "img-7",
    prompt: "Night city",
    imageUrl: "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=400",
    height: 360,
    },
    {
    id: "img-8",
    prompt: "Космический пейзаж",
    imageUrl: "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=400",
    height: 440,
    },
    {
    id: "img-9",
    prompt: "Весенний сад",
    imageUrl: "https://images.unsplash.com/photo-1490750967868-88aa4a44a14a?w=400",
    height: 310,
    },
    {
    id: "img-10",
    prompt: "Морской закат",
    imageUrl: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400",
    height: 400,
    },
    {
    id: "img-11",
    prompt: "Портрет в стиле киберпанк",
    imageUrl: "https://images.unsplash.com/photo-1531746790095-8a5a5a5a5a5a?w=400",
    height: 500,
    },
    {
    id: "img-12",
    prompt: "Архитектура будущего",
    imageUrl: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=400",
    height: 420,
    },
  ] as TextExample[],

  //быстрые промпты
  quickPrompts: [
    "Business ideas",
    "Workout plan",
    "Dinner recipe",
    "Client email",
    "Social media post",
    "Brand slogan",
    "Gift idea",
    "Weekly to-do list",
  ] as string[],

  //факью перевод
  faqItems: [
 {
    question: "How to buy tokens?",
    answer: "You can purchase token packages in the «Token Packages» section of your profile. Choose a suitable package and click «Buy».",
  },
  {
    question: "Do tokens expire?",
    answer: "No, they don't expire. The tokens you buy stay with you forever.",
  },
  {
    question: "How to get free tokens?",
    answer: "Every day, you receive tokens depending on your loyalty level. These tokens expire daily and are credited anew each day.",
  },
  {
    question: "What does priority support provide?",
    answer: "Priority support means we answer your questions within 2 hours (during business hours) instead of the standard 24 hours, plus access to a personal manager.",
  },
] as { question: string; answer: string }[],
};